import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import { AllRoles } from "./team-member-roles.type";

@Injectable({
    providedIn: 'root'
})
export class TeamMemberRolesService {
    constructor(
        private http: HttpClient
    ) {}

    roles(teamId: string) {
        return this.http.get<AllRoles>('/api/team/' + teamId + '/roles').pipe(
            map(res => new AllRoles(res.availableFeatures, res.availableRoles)),
            catchError((err: HttpErrorResponse) => {
                if (err.status === 404) {
                    return of(null);
                }
            })
        );
    }
}